import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import Modal from 'react-modal';
import * as yup from 'yup';

// material ui
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

// graphql
import { useCreatePaymentGatewayMutation } from '@/generated/graphql';

// interfaces
import type { ICashierTable, IAddPaymentGatewayInput } from '@/shared/interfaces';

import { MdOutlinePostAdd } from 'react-icons/md';
import { useState } from 'react';

interface IUsherProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refetch: () => void;
}

export const ModalAddPaymentGateway = ({ open, setOpen, refetch }: IUsherProps) => {
  const handleClose = () => setOpen(false);

  const { reset, handleSubmit, control } = useForm<IAddPaymentGatewayInput>({
    mode: 'onChange',
    defaultValues: {
      name: '',
      accountNumber: '',
    },
  });

  const [createPaymentGateway] = useCreatePaymentGatewayMutation();

  const onSubmit = async (dataInput: IAddPaymentGatewayInput) => {
    const { name, accountNumber } = dataInput;

    const { data } = await createPaymentGateway({
      variables: { input: { name, accountNumber } },
    });

    refetch();
    handleClose();
    reset();
  };

  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={handleClose}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: 'inherit',
            backgroundColor: 'rgba(25, 25, 25, 0.75)',
          },
          content: {
            width: '400px',
            overflow: 'unset',
            position: 'absolute',
            margin: '0.1% auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: 0,
            marginRight: '-50%',
            transform: 'translate(-50%, -48vh)',
            border: '0px',
            background: 'transparent',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
          },
        }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            overflow: 'unset',
            borderRadius: '5px',
          }}
          mt={9}>
          <Box sx={{ px: 5, py: 2 }} alignItems={'center'}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography gutterBottom variant="subtitle2" m={0}>
                Add Payment Gateway
              </Typography>
              <MdOutlinePostAdd fontSize={18} />
            </Stack>
          </Box>
          <Divider />

          <Box px={5} pt={2} pb={2}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid>
                <Controller
                  name="name"
                  control={control}
                  rules={{
                    required: 'Name is required',
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Name"
                      variant="standard"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error ? fieldState.error.message : null}
                      slotProps={{ inputLabel: { shrink: true } }}
                      sx={{ mt: 5 }}
                    />
                  )}
                />
                <Controller
                  name="accountNumber"
                  control={control}
                  rules={{
                    required: 'Account number is required',
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Account Number"
                      variant="standard"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error ? fieldState.error.message : null}
                      slotProps={{ inputLabel: { shrink: true } }}
                      sx={{ mt: 5 }}
                    />
                  )}
                />
              </Grid>
              <Grid container justifyContent={'end'} mt={5}>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  sx={{
                    background: 'grey',
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    textTransform: 'unset',
                  }}
                  onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  sx={{
                    ml: 1,
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    textTransform: 'unset',
                  }}
                  type="submit"
                  size="small"
                  variant="contained">
                  Create
                </Button>
              </Grid>
            </form>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
